import { TitanSpine } from "@lib/titan2/dist/game/control/TitanSpine";
import { TitanText } from "@lib/titan2/dist/game/control/TitanText";
import { DestroyUtil } from "@lib/titan2/dist/util/view/DestroyUtil";
import { ViewUtils } from "@lib/titan2/dist/util/view/ViewUtils";
import { AbstractPayTableCell } from "./AbstractPayTableCell";
import { PayTableIcon } from "./PayTableIcon";
/**
 * PayTableCell.ts
 */
export class PayTableCell extends AbstractPayTableCell {
    create() {
        super.create();
        this.background = TitanSpine.createSpine(this, this.uiProperties.backgroundProperties);
        this.effects = TitanSpine.createSpine(this, this.uiProperties.effectsProperties);
        if (this.uiProperties.iconProperties) {
            this.icon = new PayTableIcon(this.uiProperties.iconProperties);
            this.addChild(this.icon);
        }
        this.inactiveLabel = ViewUtils.createField(this, this.uiProperties.inactiveLabelProperties);
        this.inactiveField = ViewUtils.createField(this, this.uiProperties.inactiveFieldProperties);
        this.inactiveOrField = ViewUtils.createField(this, this.uiProperties.inactiveOrFieldProperties);
        this.inactiveAltField = ViewUtils.createField(this, this.uiProperties.inactiveAltFieldProperties);
        this.activeLabel = ViewUtils.createField(this, this.uiProperties.activeLabelProperties);
        this.activeField = ViewUtils.createField(this, this.uiProperties.activeFieldProperties);
        this.activeOrField = ViewUtils.createField(this, this.uiProperties.activeOrFieldProperties);
        this.activeAltField = ViewUtils.createField(this, this.uiProperties.activeAltFieldProperties);
        this.highlightField = ViewUtils.createField(this, this.uiProperties.highlightFieldProperties);
        this.highlightOrField = ViewUtils.createField(this, this.uiProperties.highlightOrFieldProperties);
        this.highlightAltField = ViewUtils.createField(this, this.uiProperties.highlightAltFieldProperties);
    }
    destroy() {
        super.destroy();
        DestroyUtil.destroy(this.background);
        DestroyUtil.destroy(this.effects);
        this.background = null;
        this.effects = null;
        DestroyUtil.destroy(this.inactiveLabel);
        DestroyUtil.destroy(this.activeLabel);
        this.inactiveLabel = null;
        this.activeLabel = null;
        DestroyUtil.destroy(this.icon);
        this.icon = null;
        DestroyUtil.destroy(this.inactiveField);
        DestroyUtil.destroy(this.activeField);
        DestroyUtil.destroy(this.highlightField);
        this.inactiveField = null;
        this.activeField = null;
        this.highlightField = null;
        DestroyUtil.destroy(this.inactiveOrField);
        DestroyUtil.destroy(this.activeOrField);
        DestroyUtil.destroy(this.highlightOrField);
        this.inactiveOrField = null;
        this.activeOrField = null;
        this.highlightOrField = null;
        DestroyUtil.destroy(this.inactiveAltField);
        DestroyUtil.destroy(this.activeAltField);
        DestroyUtil.destroy(this.highlightAltField);
        this.inactiveAltField = null;
        this.activeAltField = null;
        this.highlightAltField = null;
        this.useIcon = null;
    }
    setLabel(key) {
        if (this.inactiveLabel) {
            const label = this.langManager.getLang(key);
            this.inactiveLabel.setText(label);
            this.activeLabel.setText(label);
        }
    }
    update(amount) {
        let value = amount > 0 ? this.formatCurrency(amount) : "";
        if (this.activeField) {
            this.inactiveField.setText(value, true);
            this.activeField.setText(value, true);
            this.highlightField.setText(value, true);
        }
    }
    inactive() {
        if (this.uiProperties.off) {
            this.background.visible = true;
            this.background.play(this.uiProperties.off, false);
        }
        else {
            this.background.visible = false;
        }
        this.effects.gotoAndStop(0, this.uiProperties.activeEffect);
        this.hideFields();
        TitanText.showField(this.inactiveField);
        TitanText.showField(this.inactiveLabel);
    }
    active() {
        if (this.uiProperties.active) {
            this.background.visible = true;
            this.background.play(this.uiProperties.active, false);
        }
        else {
            this.background.visible = false;
        }
        this.effects.gotoAndStop(0, this.uiProperties.activeEffect);
        this.hideFields();
        TitanText.showField(this.inactiveField);
        TitanText.showField(this.inactiveLabel);
    }
    current() {
        if (this.uiProperties.active) {
            this.background.visible = true;
            this.background.play(this.uiProperties.active, false);
        }
        else {
            this.background.visible = false;
        }
        this.effects.play(this.uiProperties.activeEffect, true);
        this.hideFields();
        TitanText.showField(this.activeField);
        TitanText.showField(this.activeLabel);
    }
    highlight() {
        if (this.uiProperties.active) {
            this.background.visible = true;
            this.background.play(this.uiProperties.active, false);
        }
        else {
            this.background.visible = false;
        }
        this.effects.play(this.uiProperties.activeEffect, false);
        this.hideFields();
        TitanText.showField(this.highlightField);
        TitanText.showField(this.inactiveLabel);
    }
    hideFields() {
        TitanText.hideField(this.inactiveLabel);
        TitanText.hideField(this.activeLabel);
        TitanText.hideField(this.inactiveField);
        TitanText.hideField(this.activeField);
        TitanText.hideField(this.highlightField);
    }
    updateSize(properties) {
        this.uiProperties = properties;
        this.resizeView(this.background, this.uiProperties.backgroundProperties);
        this.resizeView(this.effects, this.uiProperties.backgroundProperties);
        this.resizeView(this.inactiveLabel, this.uiProperties.inactiveLabelProperties);
        this.resizeView(this.activeLabel, this.uiProperties.activeLabelProperties);
        this.resizeView(this.highlightField, this.uiProperties.highlightFieldProperties);
        this.resizeView(this.activeField, this.uiProperties.activeFieldProperties);
        this.resizeView(this.inactiveField, this.uiProperties.inactiveFieldProperties);
    }
    getHeight() {
        return this.uiProperties.inactiveLabelProperties?.size.y || this.background.height;
    }
    getWidth() {
        return this.uiProperties.labelSize.x;
    }
    getBackground() {
        return this.background;
    }
    getEffects() {
        return this.effects;
    }
    getId() {
        return this.uiProperties.id;
    }
}
//# sourceMappingURL=PayTableCell.js.map